// ETHRAEON Contact page · Phase S
// (c) S. Jason Prohaska (ingombrante) 2024-2026

export function Contact() {
  return (
    <main className="min-h-screen bg-white dark:bg-neutral-950 text-neutral-900 dark:text-neutral-50">
      <section className="max-w-3xl mx-auto px-6 py-24">
        <h1 className="text-4xl md:text-5xl font-light">Contact</h1>
        <p className="mt-8 text-lg text-neutral-700 dark:text-neutral-300">
          Whether you are exploring Ethraeon or integrating it into your organization, we are here
          to help calmly, clearly, and without pressure.
        </p>
        <div className="mt-8 rounded-xl border border-neutral-200 dark:border-neutral-800 p-6">
          <p className="text-sm text-neutral-600 dark:text-neutral-400">Reach the founder directly:</p>
          <p className="mt-2 font-mono text-neutral-900 dark:text-neutral-50">
            <a href="mailto:jason@ethraeon.systems" className="hover:underline">
              jason@ethraeon.systems
            </a>
          </p>
        </div>
      </section>
    </main>
  );
}
